module.exports = __webpack_public_path__ + "fonts/fa-light-300.fcac9514.woff";